import { useErrorNotification } from '@/hooks/use-error-notification';
import { normalizeApiError } from '@/utils/error-utils';
import { useEffect, useRef } from 'react';

type UseSimulationQueryErrorNotificationOptions = {
  isError: boolean;
  error: unknown;
  title: string;
};

export const useSimulationQueryErrorNotification = ({
  isError,
  error,
  title,
}: UseSimulationQueryErrorNotificationOptions) => {
  const showErrorNotification = useErrorNotification();
  const lastNotifiedErrorRef = useRef<unknown>(null);

  useEffect(() => {
    if (!isError || !error) {
      lastNotifiedErrorRef.current = null;
      return;
    }

    if (lastNotifiedErrorRef.current === error) {
      return;
    }

    lastNotifiedErrorRef.current = error;

    showErrorNotification(normalizeApiError(error), title);
  }, [isError, error, title, showErrorNotification]);
};
